import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/check-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM400 432v-352h-352v352h352zM364.1 190.3l-172.6 171.2c-4.7 4.7-12.3 4.6-17-0.1l-90.8-91.5c-4.7-4.7-4.6-12.3 0.1-17l22.7-22.5c4.7-4.7 12.3-4.6 17 0.1l59.8 60.3 141.4-140.2c4.7-4.7 12.3-4.6 17 0.1l22.5 22.7c4.7 4.7 4.6 12.3-0.1 17z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/check-square.js
// module id = 1707
// module chunks = 0